import NodeRSA from 'node-rsa';

const key = new NodeRSA({ b: 512 });
const publicKey = process.env.VUE_APP_MICROSITE_PUBLIC;
const pub = key.importKey(publicKey, 'pkcs1-public-pem');

export default pub;
